export const c_menu_m_flyout__menu_m_left_right_offset = {
  "name": "--pf-v6-c-menu--m-flyout__menu--m-left--right-offset",
  "value": "0px",
  "var": "var(--pf-v6-c-menu--m-flyout__menu--m-left--right-offset)"
};
export default c_menu_m_flyout__menu_m_left_right_offset;